import { pdfExportSlice } from '@Store/slices/pdfExportSlice';

export const {
  deletePdfSection,
  setOriginalDataLists,
  deleteIndividualList,
  resetPdfSection,
  resetOverallPage,
} = pdfExportSlice.actions;
